import React from "react";
export const freezeLine = (id) => {
  var lines = document.getElementsByClassName("line" + id);
  for (var i = 0; i < lines.length; i++) {
    lines[i].querySelector("input").setAttribute("disabled", "true");
  }
};

const Board = (props) => {
  let ci = 1;
  let li = 1;
  let id = 0;
  let delay = 1;

  const addLetter = (e) => {
    props.addLetter(e);
  };

  return (
    <div className="board">
      <ul>
        {props.inputs.map((field) => {
          id++;
          ci++;
          if (ci == 6) {
            ci = 1;
            if (li != 5) li++;
          }

          return (
            <React.Fragment key={id}>
              <li className={"line" + field.line}>
                <input
                  id={
                    field.status === "FOUND"
                      ? "BOARD_FOUND"
                      : field.status === "CONTAINS"
                      ? "BOARD_CONTAINS"
                      : field.status === "BAD"
                      ? "BOARD_BAD"
                      : ""
                  }
                  aria-label={field.line + ":" + field.column}
                  maxLength={1}
                  type="text"
                  className={"wotdLetterInput"}
                  readOnly
                  defaultValue={field.val}
                  disabled={field.frozen ? true : false}
                  onChange={(e) => {
                    addLetter(e);
                  }}
                ></input>
              </li>
              {li != field.line ? <br></br> : <></>}
            </React.Fragment>
          );
        })}
      </ul>
    </div>
  );
};

export default Board;
